export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response?.data.error.validationErrors.forEach((error) => {
    const message = error.message;

    if (message.indexOf('DEMANDE_IMPRESSION_INCORRECT_SOCIETE') !== -1) {
      const societeEmplacement = error.message.split('@')[1];
      const societeDemande = error.message.split('@')[2].split('|')[0];

      messages.push({
        message: 'editionDemandeImpression.validation.societe',
        parametres: {
          societeEmplacement,
          societeDemande,
        },
      });
    }
    if (message.indexOf('DEMANDE_IMPRESSION_INCORRECT_DISPOSITIF') === 0) {
      const code = error.message.split('@')[1].split('|')[0];
      messages.push({
        message: 'editionDemandeImpression.validation.incorrectDispositif',
        parametres: {
          code,
        },
      });
    }
    if (message.indexOf('DEMANDE_IMPRESSION_CLIENT_AND_DISPOSITIF_CLIENT_NOT_MATCH') === 0) {
      messages.push({
        message: 'editionDemandeImpression.validation.clientDifferent',
      });
    }

    if (message.indexOf('CLIENT_DEMANDE_NOT_LIEU_DE_STOCKAGE') === 0) {
      messages.push({
        message: 'editionDemandeImpression.validation.clientLieuStockage',
      });
    }

    if (message.indexOf('TYPEOT_IMPRESSION_MISSING') === 0) {
      messages.push({
        message: 'editionDemandeImpression.validation.typeOtMissing',
      });
    }
    if (message.indexOf('UNABLE_TO_DELETE') === 0) {
      messages.push({
        message: 'editionDemandeImpression.validation.foreignKeyConstraint',
      });
    }
  });
}
